"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.needMoreInfoEpic = exports.sendMoreInfoEpic = void 0;

var _reduxObservable = require("redux-observable");

var _operators = require("rxjs/operators");

var _needMoreInfo = require("./needMoreInfo.types");

var _needMoreInfo2 = require("./needMoreInfo.actions");

var sendMoreInfoEpic = function sendMoreInfoEpic(action$, state$, _ref) {
  var createGiftService = _ref.createGiftService,
      _ref$messagesService = _ref.messagesService,
      errorHandler = _ref$messagesService.errorHandler,
      showGlobalMessage = _ref$messagesService.showGlobalMessage;
  return action$.pipe((0, _reduxObservable.ofType)(_needMoreInfo.SEND_MORE_INFO_REQUEST), (0, _operators.mergeMap)(function (_ref2) {
    var _ref2$payload = _ref2.payload,
        info = _ref2$payload.info,
        giftId = _ref2$payload.giftId;
    return createGiftService.sendMoreInfo({
      info,
      giftId
    }).pipe((0, _operators.mergeMap)(function () {
      return [(0, _needMoreInfo2.sendMoreInfoSuccess)(giftId), showGlobalMessage({
        text: 'Thank you!',
        type: 'success'
      })];
    }), (0, _operators.catchError)(errorHandler({
      callbacks: _needMoreInfo2.sendMoreInfoFail
    })));
  }));
};

exports.sendMoreInfoEpic = sendMoreInfoEpic;
var needMoreInfoEpic = [sendMoreInfoEpic];
exports.needMoreInfoEpic = needMoreInfoEpic;